import React, { useState, useEffect } from "react";
import * as CDS from "../../../styles/CourseDetailStyled";
import * as CDD from "../../../styles/CourseDetStyled";
import * as RNS from "../../../styles/RenewStyled";
import * as LS from "../../../styles/LearnerStyled";
import mediaImage from "../../../assets/images/mediaImage.png";
import downArrow from "../../../assets/images/downArrow.png";
import editDark from "../../../assets/images/editDark.png";
import YearInput from "../../../components/DatePicker";
import CourseView from "./CourseViewBackup";
import * as RS from "../../../styles/ReqStyled";
import Modal from "../../../components/Modal/Modal";
import { Formik, Field, Form, FieldArray } from "formik";
import Input from "../../../components/Inputs/InputAdd";
import axios from "../../../utils/axios";
import { Course } from "../../../utils/api";
import { useSelector } from "react-redux";
import { get } from "lodash";
import moment from "moment";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import {
  setCourseViewId,
  setErrorPop,
  setErrorPopMsg,
} from "../../../store/action";
import * as SEC from "../../../styles/SectionStyled";
import { PopUp } from "../../../components/PopUp/PopUp";
import successModal from "../../../assets/images/successModal.png";
import { useLocation } from "react-router-dom";
import { encryptData } from "../../../utils/Helpers";
import { batchValidator } from "../../../utils/validator";
import * as CS from "../../../styles/CommonStyled";
import darkArrow from "../../../assets/images/darkArrow.png";
import darkRight from "../../../assets/images/darkRight.png";
import lighRight from "../../../assets/images/lighRight.png";
import lightLeft from "../../../assets/images/lightLeft.png";
import pendingIcon from "../../../assets/images/pendingIcon.png";
import rejectIcon from "../../../assets/images/rejectIcon.png";
import approvedIcon from "../../../assets/images/approvedIcon.png";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { Table } from "antd";

const ReqAdditionalHistory = ({ navigate, theme, dispatch, localState }) => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(location?.state?.popUp || false);
  const courseId = useSelector((state) => state?.courseId);
  const [stateData, setStateData] = useState(location?.state?.popUp);
  const selectLangJson = useSelector((state) => state?.selectLangJson);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [userList, setUserList] = useState([]);
  const [courseDetailData, setCourseDetailData] = useState([]);
  const [feildLoading, setFeildLoading] = useState(false);
  const selectLang = useSelector((state) => state.selectLang);
  const [addiValue, setAddiValue] = useState({});
  const [showsucess, setShowsucess] = useState(false);
  const [errorObj, setErrorObj] = useState({});
  const pageLimitLearner = 10;
  const numberOfPages = Math.ceil(totalCount / pageLimitLearner);

  const skeletonBaseColor = theme ? "#1F242F" : "#EDEEF1";
  const skeletonHighlightColor = theme ? "#1F242F" : "#EDEEF1";

  const screenWidth = window.innerWidth;

  const getLearner = async () => {
    setFeildLoading(true);
    let url = `${Course.getActiveLog}`;
    const formValue = {
      limit: 10,
      page: currentPage,
      courseId: courseId,
      key: "batch_size",
    };
    try {
      const { data } = await axios.post(url, formValue);
      console.log(data);

      if (screenWidth < 789) {
        setFeildLoading(false);
        setUserList((courseList) => [...courseList, ...data.result?.docs]);
      } else {
        setFeildLoading(false);
        setUserList(data.result?.docs);
      }
      setTotalCount(data.result?.totalDocs);
    } catch (error) {
      setFeildLoading(false);
      // alert(error.response.data.message);
      console.log(error.response.data.message);
      if (error.response && error.response.status === 400) {
        dispatch(setErrorPop(true));
        dispatch(setErrorPopMsg(error?.response?.data?.message));
      }
    }
  };

  useEffect(() => {
    if (currentPage) getLearner(-1, "createdAt");
  }, [currentPage, selectLang]);

  // const getStatus = (e) => {
  //   if (e === "approved") {
  //     return (
  //       <CS.StatusButton isActive={true}>
  //         <img src={approvedIcon} data-tooltip-id="download-approve" alt="" />
  //         <ReactTooltip
  //           id="download-approve"
  //           place="bottom"
  //           content="Approved"
  //         />
  //       </CS.StatusButton>
  //     );
  //   } else if (e === "reject") {
  //     return (
  //       <CS.StatusButton isActive={false}>
  //         <img src={rejectIcon} data-tooltip-id="download-reject" alt="" />
  //         <ReactTooltip id="download-reject" place="bottom" content="Reject" />
  //       </CS.StatusButton>
  //     );
  //   } else if (e === "pending") {
  //     return (
  //       <CS.StatusButton>
  //         <img src={pendingIcon} data-tooltip-id="download-pending" alt="" />
  //         <ReactTooltip
  //           id="download-pending"
  //           place="bottom"
  //           content="Pending"
  //         />
  //       </CS.StatusButton>
  //     );
  //   } else {
  //     return (
  //       <CS.StatusButton>
  //         <img src={pendingIcon} data-tooltip-id="download-pending" alt="" />
  //         <ReactTooltip
  //           id="download-pending"
  //           place="bottom"
  //           content="Pending"
  //         />
  //       </CS.StatusButton>
  //     );
  //   }
  // };

  // Column
  
  const getStatus = (status, id) => {
    const tooltipId = `tooltip-${id}`; // Unique ID for each row
  
    if (status === "approved") {
      return (
        <CS.StatusButton isActive={true}>
          <img src={approvedIcon} data-tooltip-id={tooltipId} alt="" />
          <ReactTooltip id={tooltipId} place="bottom" content="Approved" />
        </CS.StatusButton>
      );
    } else if (status === "reject") {
      return (
        <CS.StatusButton isActive={false}>
          <img src={rejectIcon} data-tooltip-id={tooltipId} alt="" />
          <ReactTooltip id={tooltipId} place="bottom" content="Reject" />
        </CS.StatusButton>
      );
    } else if (status === "pending") {
      return (
        <CS.StatusButton>
          <img src={pendingIcon} data-tooltip-id={tooltipId} alt="" />
          <ReactTooltip id={tooltipId} place="bottom" content="Pending" />
        </CS.StatusButton>
      );
    } else {
      return (
        <CS.StatusButton>
          <img src={pendingIcon} data-tooltip-id={tooltipId} alt="" />
          <ReactTooltip id={tooltipId} place="bottom" content="Pending" />
        </CS.StatusButton>
      );
    }
  };
  
  const columnsLearner = [
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      width: 250,
      align: "center",
      ellipsis: true,
      render: (text, record) => <div>{record.title || ""}</div>,
    },
    // {
    //   title: "Before (Old) Licence",
    //   dataIndex: "old",
    //   key: "old",
    //   width: 100,
    //   align: "center",
    //   ellipsis: true,
    //   render: (text, record) => <div>{record.old}</div>,
    // },
    {
      title: "Update Request",
      dataIndex: "new",
      key: "new",
      width: 100,
      align: "center",
      ellipsis: true,
      render: (text, record) => <div>{record.new}</div>,
    },
    {
      title: "Request By",
      dataIndex: "request_by",
      key: "request_by",
      width: 100,
      align: "center",
      ellipsis: true,
      render: (text, record) => <div>{record.request_by}</div>,
    },
    {
      title: selectLangJson?.status,
      dataIndex: "status",
      key: "status",
      align: "center",
      width: 200,
      ellipsis: true,
      render: (text, record) => (
        <div style={{ width: "100%" }}>
       {getStatus(record?.status, record?._id)} 
        </div>
      ),
    },
  ];
  return (
    <>
      <CDS.DetailContainer themeColor={theme}>
        {/* <CDS.RowTabsContainer themeColor={theme}>
          <CDS.RowTabs
            activecolor={
              window.location.pathname === "/client-admin/courses-manage/renew"
            }
            themeColor={theme}
            onClick={() => {
              navigate("/client-admin/courses-manage/renew");
            }}
          >
            <p>Renew</p>
          </CDS.RowTabs>
          <CDS.RowTabs
            activecolor={
              window.location.pathname ===
              "/client-admin/courses-manage/renew/history"
            }
            onClick={() => {
              navigate("/client-admin/courses-manage/renew/history");
            }}
            themeColor={theme}
          >
            <p>History</p>
          </CDS.RowTabs>
        </CDS.RowTabsContainer> */}
        <CDS.MultiHeadingRow themeColor={theme}>
          <CDS.HeadingBox
            themeColor={theme}
            to="/client-admin/courses-manage/request-additional-learners"
            onClick={() => {}}
            activecolor={
              window.location.pathname ===
              "/client-admin/courses-manage/request-additional-learners"
            }
          >
            {selectLangJson.additional_licenses}
          </CDS.HeadingBox>
          <CDS.HeadingBox
            themeColor={theme}
            to="/client-admin/courses-manage/request-additional-learners/history"
            onClick={() => {}}
            activecolor={
              window.location.pathname ===
              "/client-admin/courses-manage/request-additional-learners/history"
            }
          >
            History
          </CDS.HeadingBox>
        </CDS.MultiHeadingRow>
        <CDS.DetailCon themeColor={theme}>
          <CDS.DetailInnerCon>
            {feildLoading ? (
              <Skeleton
                width={200}
                baseColor={skeletonBaseColor}
                highlightColor={skeletonHighlightColor}
                height={28}
                style={{
                  borderRadius: "5px",
                  margin: "1rem 0",
                }}
              />
            ) : (
              <RS.ReqTitle themeColor={theme}>History</RS.ReqTitle>
            )}
            <SEC.ParentTable style={{ marginTop: "1rem" }}>
              <SEC.TableBox
                // checkCon={selectedRowKeys?.length === userList?.length}
                themeColor={theme}
              >
                <Table
                  rowKey={(record) => record._id}
                  style={{
                    width: "100%",
                    minHeight: "500px",
                  }}
                  // rowSelection={rowSelection}
                  columns={columnsLearner}
                  className={
                    theme
                      ? "dark-table border-border"
                      : "light-table border-border"
                  }
                  dataSource={userList}
                  scroll={{ x: true }}
                  pagination={{
                    current: currentPage,
                    pageSize: pageLimitLearner,
                    total: totalCount,
                    onChange: (page) => {
                      console.log(page);
                      setCurrentPage(page);
                    },
                    // You can use this property to customize the rendered pagination component
                    itemRender: (current, type, originalElement) => {
                      const isDisabled = currentPage === 1;
                      if (type === "prev") {
                        return (
                          <SEC.PagiButton
                            themeColor={theme}
                            disabled={isDisabled}
                            onClick={() => {
                              !isDisabled && setCurrentPage(currentPage - 1);
                            }}
                          >
                            <img
                              src={theme ? lightLeft : darkArrow}
                              style={{ marginRight: "8px" }}
                              alt=""
                            />{" "}
                            <p>{selectLangJson.previous}</p>
                          </SEC.PagiButton>
                        );
                      }
                      if (type === "next") {
                        const isDisabled = currentPage === numberOfPages;
                        return (
                          <SEC.PagiButtonNext
                            disabled={isDisabled}
                            themeColor={theme}
                            onClick={() => {
                              !isDisabled && setCurrentPage(currentPage + 1);
                            }}
                          >
                            <p>{selectLangJson.next}</p>
                            <img
                              src={theme ? lighRight : darkRight}
                              style={{ marginLeft: "8px" }}
                              alt=""
                            />
                          </SEC.PagiButtonNext>
                        );
                      }
                      return originalElement;
                    },
                  }}
                />
              </SEC.TableBox>
            </SEC.ParentTable>
          </CDS.DetailInnerCon>
        </CDS.DetailCon>
      </CDS.DetailContainer>
    </>
  );
};

export default ReqAdditionalHistory;
